import { useCallback, useMemo } from 'react';
import {
  useGlobalComponentForAttribute,
  TableInheritedProps
} from '@rhino-project/core/hooks';
import { CellImage } from '../../table/cells/CellImage';

export const ModelCellAttachmentImageBase = ({
  getValue,
  ...props
}: TableInheritedProps) => {
  const syntheticGetValue = useCallback(() => getValue!()?.url, [getValue]);

  const altText = useMemo(
    () => getValue!()?.display_name || getValue!()?.url,
    [getValue]
  );

  return <CellImage alt={altText} getValue={syntheticGetValue} {...props} />;
};

export const ModelCellAttachmentImage = (props: TableInheritedProps) =>
  useGlobalComponentForAttribute(
    'ModelCellAttachmentImage',
    ModelCellAttachmentImageBase,
    props
  );
